import { render, staticRenderFns } from "./FooterFixed.vue?vue&type=template&id=41c89f6d&scoped=true&"
import script from "./FooterFixed.vue?vue&type=script&lang=js&"
export * from "./FooterFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c89f6d",
  null
  
)

export default component.exports